import { Injectable } from '@angular/core';
import { BaseService, IPaginatorService } from './base';
import { AttributeType } from '../model/attribute-type';
import { HttpClient } from '@angular/common/http';
import { BasePaginator } from '../model/base/base-model';
import { Observable, of, from } from 'rxjs';
import { tap, finalize, share, switchMap } from 'rxjs/operators';
import { SyncService } from '@vex/http-service/sync.service';
import { AttributeDataCleanupResult } from '@vex/model/attribute-data-cleanup';
@Injectable({
    providedIn: 'root'
})
export class AttributeTypeService extends IPaginatorService {
    readonly baseEndpoint = 'AttributeType';
    cache: any = <any>{};
    cachedObservable: Observable<any> = <Observable<any>>{};

    constructor(private http: HttpClient, private syncService: SyncService) {
        super();
    }

    getBaseTypes(): Observable<string[]> {
        return this.http.get<string[]>(this.baseUrl + 'Collection/Attributes');
    }

    getAttributeTypesForSelect(): Observable<AttributeType[]> {
        return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetAttributeTypesForSelect');
    }

    getAttributeDataCleanupDryRun(): Observable<AttributeDataCleanupResult> {
        return this.http.get<AttributeDataCleanupResult>(
            this.baseUrl + 'AttributeData/CleanupDuplicates/DryRun'
        );
    }

    applyAttributeDataCleanup(): Observable<AttributeDataCleanupResult> {
        return this.http.post<AttributeDataCleanupResult>(
            this.baseUrl + 'AttributeData/CleanupDuplicates/Apply',
            { Confirm: true }
        );
    }

    resetAttributeDataCache(): Promise<void> {
        return this.syncService.resetTableCache('AttributeData');
    }

    getPaginatedData<AttributeType>(
        sort: string,
        order: string,
        page: number,
        size: number,
        filter: string
    ): Observable<BasePaginator<AttributeType>> {
        let url = this.baseUrl + this.baseEndpoint + '/GetPaginated/' + page + '/' + size + '?';

        if (sort && order) {
            url += `sort=${sort}&order=${order}`;
        }
        if (filter) {
            url += (sort ? '&' : '') + `filter=${filter}`;
        }

        return this.http.get<BasePaginator<AttributeType>>(url);
    }

    getAttributeTypeById<AttributeType>(id: string): Observable<AttributeType> {
        return this.http.get<AttributeType>(this.baseUrl + this.baseEndpoint + '/getById/' + id);
    }

    getByIds(attributeTypeIds: any[]): Observable<any[]> {
        return from(
            this.syncService.checkAndSyncData('AttributeType','AttributeType').then(async () => {
                let attributeTypes = await this.syncService.sync('AttributeType');
                let data = this.getCollectionEntryByIds(attributeTypeIds, attributeTypes)
                return data;
            })
        );
    }

    getCollectionEntryByIds(attributeTypeIds, attributeTypes) {
        const result = [];
        for (const attributeTypeId of attributeTypeIds) {
        let collection = attributeTypes.find(x=> x.Id == attributeTypeId);
        if(collection) {
            result.push(collection);
        }
        }
        return result;
    }

    createAttributeType(attributeType: AttributeType): Observable<AttributeType> {
        this.syncService.lastSyncTime['AttributeTypeUpdateBySelf'] = true;
        return this.http.post<AttributeType>(this.baseUrl + this.baseEndpoint + '', attributeType);
    }

    updateAttritbuteType(attributeType: AttributeType): Observable<AttributeType> {
        this.syncService.lastSyncTime['AttributeTypeUpdateBySelf'] = true;
        return this.http.put<AttributeType>(
            this.baseUrl + this.baseEndpoint + '/' + attributeType.Id + '?id=' + attributeType.Id,
            attributeType
        );
    }

    deleteAttritbuteType(id: string): Observable<AttributeType> {
        this.syncService.lastSyncTime['AttributeTypeUpdateBySelf'] = true;
        return this.http.delete<AttributeType>(this.baseUrl + this.baseEndpoint + '/' + id);
    }

    deleteAttritbuteTypes(risk: any[]): Observable<any[]> {
        this.syncService.lastSyncTime['AttributeTypeUpdateBySelf'] = true;
        return this.http.post<any[]>(
            this.baseUrl + this.baseEndpoint + '/DeleteAttributeTypes',
            risk
        );
    }

    getAllAtributes(): Observable<any> {
        return from(
            this.syncService.checkAndSyncData('AttributeType','AttributeType').then(async () => {
                let data = await this.syncService.sync('AttributeType');
                return data;
            })
        )
    }
    
    getAttributeType(id) {
        let observable: Observable<any>;
        if (this.cache[id]) {
            observable = of(this.cache[id]);
        }  else if (this.cachedObservable[id]) {
            observable = this.cachedObservable[id];
        } else {
        this.cachedObservable[id] = this.getAttributeTypeById(id)
            .pipe(
            tap(res => this.cache[id] = res),
            share(),
            finalize(() => this.cachedObservable[id] = null)
            );
            observable = this.cachedObservable[id];
        }
        return observable;
    }

    getPaginatedPost(filter:any): any{
        return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/GetPaginatedPost', filter);
    }

    updateReviewStatus(data: any): Observable<any>{
        return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/UpdateReviewStatus', data);
    }
}
